import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import axios from '~/data/http/axios'
import queryString from 'query-string'

export default function SalesmateError() {
    const parsed = queryString.parse(window.location.search)
    const history = useHistory()
    const goDisconnect = async () => {
        try {
            await axios.get('/application/salesmate/disconnect')
        } catch (e) {
            history.push('/cp/company/integrations')
        }
    }

    let error = 'You will need to disconnect and reconnect.'
    if (parsed.code == '403') {
        // invalid permissions in salesmate, so ask them to check they can create workflows in salesmate and try again
        error =
            'We were not able to create workflows in Salesmate. Ensure your Salesmate account is able to create workflows.'
    }

    return (
        <div className='row'>
            <div className='col-xs-12 col-sm-8 col-md-4 col-lg-4 col-sm-offset-2 col-md-offset-4 col-lg-offset-4 center-xs'>
                <Paper>
                    <h4 className='mar-b25'>There has been a problem with your Salesmate integration</h4>
                    <div className='mar-b25'>{error}</div>
                    <Button text='Disconnect' className='button-primary' onClick={goDisconnect} />
                </Paper>
            </div>
        </div>
    )
}
